module.exports = __webpack_public_path__ + "static/media/product35.fc65364c.jpg";